<script lang="ts">
    import { _ } from "svelte-i18n"
    import { location } from "../../../i18n"
    import { cart, checkoutData, getAsyncCartSum } from "../../../functionTools/cart"
    import { initialLocale } from "../../../i18n"
    import { spaLink } from "../../../functionTools/navigation"

    const allTabs = [
        {
            name: $_("checkout.info-and-shipping"),
            link: `/${initialLocale}/checkout`,
            step: 0,
        },
        {
            name: $_("checkout.payment"),
            link: `/${initialLocale}/checkout/payment`,
            step: 1,
        },
        {
            name: $_("checkout.summary"),
            link: `/${initialLocale}/checkout/overview`,
            step: 2,
        },
    ]

    let cartSum: CartSum = $state()
    let tabs = $state(allTabs)

    $effect(() => {
        ;(async () => {
            cartSum = await getAsyncCartSum($cart)

            // Bei kostenlosem Warenkorb Payment-Step ausblenden
            if (cartSum?.totalGross === 0) {
                tabs = [
                    {
                        name: $_("checkout.info-and-shipping"),
                        link: `/${initialLocale}/checkout`,
                        step: 0,
                    },
                    {
                        name: $_("checkout.summary"),
                        link: `/${initialLocale}/checkout/overview`,
                        step: 1,
                    },
                ]
            } else {
                tabs = allTabs
            }
        })()
    })

    let activetab: any = $derived(tabs.find((t) => $location?.path === t.link) || tabs[0])
</script>

<ul class="processbar">
    {#each tabs as tab, idx}
        <li class:active={activetab.step == tab.step} class:checked={activetab?.step > idx}>
            {#if $checkoutData.stepsValid >= idx}
                <a href={tab.link} use:spaLink> {tab.name}</a>
            {:else}
                <span>{tab.name}</span>
            {/if}
        </li>
    {/each}
</ul>

<style lang="less">
    @import "../../../css/variables.less";

    .processbar {
        overflow: hidden;
        background: var(--surface-4);
        .border-radius(7px);
        height: 40px;
        .flex();
        list-style-type: none;
        margin: 0 0 30px 0;
        padding: 0;
        li {
            .flex();
            flex-direction: column;
            justify-content: stretch;
            a,
            span {
                background: var(--surface-4);
                color: var(--on-surface-4);
                padding: 0px 20px;
                .flex();
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100%;
                line-height: 1;
                @media (max-width: 1600px) {
                    font-size: 0.8rem;
                }
                @media (max-width: 768px) {
                    font-size: 1rem;
                }
            }
            &.active a {
                background: var(--primary);
                color: var(--on-primary);
            }
            &.checked a {
                background: var(--status-green);
                color: var(--status-on-green);
            }
        }
    }
</style>
